<div class="modal-container">
  <div class="modal-content">
    <p class="confirmation-text">
      Please confirm the selected customers and their groups?
    </p>
    <div class="tblWrapper">
        <table class="confirmation-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Group(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let customer of data.selectedData">
              <td>{{ customer.customerName }}</td>
              <td>
                  <span *ngFor="let group of customer.selectedGroups" class="group-label">
                    {{ group.groupName }}
                  </span>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    

    <div class="button-container">
      <button mat-dialog-close type="button" class="btn-cancel" (click)="onCancel()">
        Cancel
      </button>
      <button type="submit" class="btn-confirm" [disabled]="!hasValidSelection" (click)="onConfirm()">
        Publish Config
      </button>
    </div>
  </div>
</div>
